import envApi from "../api/env";

const actions = {
  async loadEnv({ commit }) {
    const result = await envApi.get();

    return commit("setEnv", result.env);
  },
};

const mutations = {
  setEnv(state, env) {
    state.env = env;
  },
};

const state = {
  env: null,
};

const getters = {};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
